const table_filter = {
	pagination: {
		from: "van",
		more_than: "meer dan",
		rows_per_page: "Regels per pagina",
	},
	table_row_empty: "Geen resultaten gevonden...",
	toolbar: {
		reset: "Reset",
		search: "Zoeken in tabel",
	},
};

export default table_filter;
